'use strict';

$(document).ready(function () {

  //SP用パンくずリスト
  if ($('#breadCrumb').length) {
    var scrollObj = new IScroll("#breadCrumb", {
      scrollX: true,
      scrollY: false,
      mouseWheel: true
    });
  }

  //PC&TB用グロナビ
  if (document.querySelector('.searchTopNav-top')) {
    var activateSubmenu = function activateSubmenu(row) {
      var $row = $(row),
          submenuId = $row.data("submenuId"),
          $submenu = $("#" + submenuId),
          height = $menu.outerHeight(),
          width = $menu.outerWidth();

      // Show the submenu
      $submenu.css({
        display: "block",
        top: "-2px",
        left: width - 4, // main should overlay submenu
        height: height // padding for main dropdown's arrow
      });

      // Keep the currently activated row's highlighted look
      $row.find("a").addClass("maintainHover");
    };

    var deactivateSubmenu = function deactivateSubmenu(row) {
      var $row = $(row),
          submenuId = $row.data("submenuId"),
          $submenu = $("#" + submenuId);

      $submenu.css("display", "none");
      $row.find("a").removeClass("maintainHover");
    };

    //中階層メニュー
    var $middleLayer = $(".searchTopNav-top > li:first-child");

    $(".dropdown-toggle").on('mouseover', function () {
      $(".popover").css("display", "none");
      $("a.maintainHover").removeClass("maintainHover");
    });

    $middleLayer.on('mouseover', function () {
      $middleLayer.addClass('is-active');
    });

    $middleLayer.on('mouseout', function () {
      $middleLayer.removeClass('is-active');
    });

    //最下層メニュー
    var $menu = $(".dropdown-menu");

    // Hook up events to be fired on menu row activation.
    $menu.menuAim({
      activate: activateSubmenu,
      deactivate: deactivateSubmenu
    });

    $(document).on('click', function () {
      $(".popover").css("display", "none");
      $("a.maintainHover").removeClass("maintainHover");
    });
  }

  $('.header_user').hover(function () {
    $(this).removeClass('is-close');
    $('.header_userMenu').removeClass('is-close');
  }, function () {
    $(this).addClass('is-close');
    $('.header_userMenu').addClass('is-close');
  });
});